// extracted by mini-css-extract-plugin
export default {"select":"PublisherSelector_select__GY6Gl"};